import type { PlanFeatureInput } from '@frameio/graphql-client/generated';
import type { FeatureInput } from './useFeatureGatePlanSuggestion';
import { useFeatureGatePlanSuggestion } from './useFeatureGatePlanSuggestion';

export function usePlanFeatureInputFromSuggestion(
  feature: FeatureInput
): PlanFeatureInput {
  const planSuggestionFeature = useFeatureGatePlanSuggestion(feature)?.feature;

  if (planSuggestionFeature) {
    return planSuggestionFeature.toUpperCase() as PlanFeatureInput;
  }

  if (typeof feature === 'object') {
    return feature.featureList[0] as PlanFeatureInput;
  }

  return feature as PlanFeatureInput;
}
